import { useParams } from 'react-router-dom';
import FicheBien from './FicheBien';

export default function FicheBienAuto() {
  const { id } = useParams();
  return <FicheBien bienId={id} />;
}